import { createReducer, on } from '@ngrx/store';
import { loadStateSuccess } from '@app/actions';
import { dig } from '@imcc/utilities';
import { initialState } from './initial-state';
import { dismissIntroduction } from './actions/dismiss-introduction';
import { IntroductionState } from './introduction-state';

export const introductionReducer = createReducer(
  initialState,
  on(loadStateSuccess, (state: IntroductionState, action) => ({
    ...state,
    dismissedAt: dig(action, 'clientStateRequestDTO', 'introductionDismissedAt'),
  })),
  on(dismissIntroduction, (state: IntroductionState, action) => ({ ...state, dismissedAt: action.dismissedAt })),
);
